import { Scale } from "../../utils/Scale"

export class AddictionRoadPos {

    static baseFps = () => 59.94125756758

    static carX = () => Scale.width() * 0.4
    static carY = () => Scale.height() * 0.74

    static carXMin = () => Scale.width() * 0.1
    static carXMax = () => Scale.width() * 0.7

    static scoresScreenX = () => Scale.x(0.16)
    static scoresScreenY = () => Scale.y(0.1)

    static usernameX = () => AddictionRoadPos.scoresScreenX() + Scale.x(0.04)

    static addictedX = () => Scale.x(0.64)
    static scoreX = () => AddictionRoadPos.addictedX() - Scale.x(0.1)

}
